import React ,{ useState,useEffect } from 'react';
import { Link } from 'react-router-dom';
import { endPoints } from "../Constants";
import { useTranslation,Trans  } from 'react-i18next';
const Footer = () => {
    const { t } = useTranslation();
    const [visitorData, setVisitorData] = useState({
        total: null,
        today: null,
        lastUpdated: null
      });
      useEffect(() => {
        fetch(`${endPoints.visitorCount}`) // Replace with your actual API
          .then(res => res.json())
          .then(data => {
            debugger;
            if(data.success=== true)
            {
                let parsedData = JSON.parse(data.data);
                setVisitorData({
                total: parsedData[0].TotalVisitors,
                today: parsedData[0].TodaysVisitors,
                lastUpdated: (new Date()).toLocaleString()
                });
            }
            else
            {
                setVisitorData({
                total: 0,
                today: 0,
                lastUpdated: (new Date()).toLocaleString()
                });
            }
          });
      }, []);
      useEffect(() => {
        const hasVisited = localStorage.getItem("hasVisited");
      
        if (!hasVisited) {
          // Call your API to increment the unique visitor count
          fetch(`${endPoints.visitorLog}`, { method: 'POST' });
        
          localStorage.setItem("hasVisited", "true");
        }
      }, []);
    return (
        <>
            <div className='bs-footer py-4 mb-4'>
                <footer className='footer'>
                    <div className='container-fluid px-4' style={{fontSize: 'small'}}>
                        <div className='footer-wrapper'>
                            <div className='row'>
                                <div className='col-lg-4 col-md-6 col-12'>
                                    <div className='leftBox'>
                                        <Link to='/'>
                                            <div className='footer-logo-wrapper'>
                                                <div className='footer-logo'>
                                                    <img
                                                        className="img-fluid"
                                                        src="/images/logo-svg.svg" // Ensure the image is placed in the public folder
                                                        alt="logo"
                                                        width={60}
                                                        height={55}
                                                    />
                                                </div>
                                                <div className='footer-logo-text'>
                                                    Griharmony Redevelopment <br></br>Stakeholder Federation
                                                </div>
                                            </div>
                                        </Link>

                                        {/* <div className='footer-title'>
                                            Redefining Redevelopment With 3 T's - Transparency, Trust & Timely Completion
                                        </div> */}

                                        <div>
                                            <Link to="/contact-us" className="bs-btn typfill typdardbg" aria-label="Navigate to Contact Us page">
                                                {t('contactUs')} <span className="icon icon-right-arrow"></span>
                                            </Link>
                                        </div>
                                        <div  style={{ marginTop: '1rem', color: '#fff' }}>
                                            <p>👥 <strong>{t('totalVisitors')}: </strong> {visitorData.total ?? ' Loading...'}</p>
                                            <p>📅 <strong>{t('todaysCount')}:</strong> {visitorData.today ?? ' Loading...'}</p>
                                            <p>🕒 <strong>{t('lastUpdated')}:</strong> {visitorData.lastUpdated ? new Date(visitorData.lastUpdated).toLocaleString() : ' Loading...'}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-md-6 col-12 mt-lg-0 mt-md-0 mt-5'>
                                    <div className='centerBox'>
                                        <div className='common-heading'>
                                           {t('usefulLinks')} 
                                        </div>

                                        <ul>
                                            <li>
                                                <Link to="/about-us" className="navbar-link">{t('aboutUs')}</Link>
                                            </li>
                                            <li>
                                                <Link to="/faq" className="navbar-link">{t('faq')}</Link>
                                            </li>
                                            <li>
                                                <Link to="/media" className="navbar-link">{t('mediaAndNews')}</Link>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className='social-icons mt-3'>
                                        <a href='https://www.youtube.com/@GRSF_YTChannel'  className="me-4">
                                            <span className="icon icon-youtube"></span>
                                        </a>
                                        <a href='https://www.facebook.com/people/GRSF-Griharmony-Redevelopment-Stakeholders-Federation/61571802876156/'  className="me-4">
                                            <span className="icon icon-facebook"></span>
                                        </a>
                                        <a href='https://twitter.com'  className="me-4">
                                            <span className="icon icon-twitter" ></span>
                                        </a>
                                        <a href='https://www.instagram.com/grsf.official/#'  className="me-4">
                                            <span className="icon icon-insta"></span>
                                        </a>
                                        <a href='https://www.linkedin.com'  className="me-4">
                                            <span className="icon icon-linkdin"></span>
                                        </a>
                                    </div>
                                </div>
                                <div className='col-lg-4 col-12 mt-lg-0 mt-md-5 mt-4'>
                                    <div className='rightBox'>
                                        <div className='box'>
                                            <div className='stickers'>
                                                <span className="icon icon-call"></span>
                                            </div>
                                            <div className='content-text'>
                                                <div className='common-heading'>
                                                    {t('haveAQuestion')}
                                                </div>
                                                <a href="tel:+918169231135" className="navbar-link">+91 8169231135</a>
                                            </div>
                                        </div>

                                        <div className='box'>
                                            <div className='stickers'>
                                                <span className="icon icon-mail"></span>
                                            </div>
                                            <div className='content-text'>
                                                <div className='common-heading'>
                                                    {t('contactUsAt')}
                                                </div>
                                                <a href="mailto:grsf.helpdesk@gmail.com" className="navbar-link">grsf.helpdesk@gmail.com</a>
                                            </div>
                                        </div>

                                        <div className='box'>
                                            <div className='stickers'>
                                                <span className="icon icon-location"></span>
                                            </div>
                                            <div className='content-text'>
                                                <div className='common-heading'>
                                                    {t('address')}
                                                </div>
                                                <a href="https://maps.app.goo.gl/BPfuQ9sUXtNBJLUt8" className="navbar-link" target="_blank" rel="noopener noreferrer">{t('addressDtls')}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='copyright'>
                            <div className='message-text'>
                                {t('footer')}
                            </div>
                            
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
}

export default Footer;
